module.exports = __webpack_public_path__ + "assets/img/202108-2.87a55eb0.png";